// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div#client-address-address-lookup-fields {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/componentStyles/addressLookup.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf","sourcesContent":["div#client-address-address-lookup-fields {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
